// src/context/AuthContext.ts
import { createContext } from 'react';

// ОБНОВЛЕННЫЙ ИНТЕРФЕЙС, теперь это единственный источник правды
export interface User {
    id?: number;
    username: string;
    role: 'user' | 'admin';
    is_blocked: boolean; // В базе данных используется is_blocked
    created_at?: string;
}

export interface AuthContextType {
    token: string | null;
    user: User | null;
    login: (newToken: string, username: string, role: 'user' | 'admin') => void;
    logout: () => void;

    // Эти функции мы будем реализовывать постепенно
    allUsers: User[];
    registerUser: (username: string, role: 'user' | 'admin') => { success: boolean, message: string };
    updateUserStatus: (username: string, isBlocked: boolean) => void;
    deleteUser: (username: string) => void;
    getUserBasicLists: (username: string) => any;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);